import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker } from "@react-google-maps/api";
import useGoogleMaps from "../../../Helpers/useGoogleMaps";
import { toast } from 'react-toastify';
import BackButton from "../../../Components/BackButton";
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import Handler from '../../../Helpers/Handler';
import { reloadWindowToPath } from '../../../Helpers/Utils';
import DatePicker from 'react-multi-date-picker';

const CarDevice = () => {
    const { id } = useParams();
    const [deviceData, setDeviceData] = useState([]);
    const [details, setDetails] = useState({});
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [disableButton, setButtonDisable] = useState(false);
    const [deviceOptions, setDeviceOptions] = useState([]);
    const [serviceDetails, setServiceDetails] = useState([]);
    const [service, setService] = useState([]);
    const [carDetails, setCarDetails] = useState({});
    const { isLoaded } = useGoogleMaps();
    const mapRef = useRef(null);
    
    const options = [
        { value: "airtel_payments_bank_netc", label: "Airtel Payments Bank" },
        { value: "au_bank", label: "AU Small Finance Bank" },
        { value: "axis_bank", label: "Axis Bank Ltd" },
        { value: "bandhan_bank", label: "Bandhan Bank" },
        { value: "bank_of_baroda", label: "Bank of Baroda" },
        { value: "bank_of_maharashtra", label: "Bank of Maharashtra" },
        { value: "bajaj_pay", label: "Bajaj Pay" },
        { value: "canara_bank", label: "Canara Bank" },
        { value: "equitas_recharge", label: "Equitas Small Finance Bank" },
        { value: "federal_bank_-", label: "Federal Bank" },
        { value: "hdfc_bank", label: "HDFC Bank" },
        { value: "icici_bank", label: "ICICI Bank" },
        { value: "idbi_bank", label: "IDBI Bank" },
        { value: "idfc_first_bank", label: "IDFC First Bank" },
        { value: "indian_bank_recharge", label: "Indian Bank" },
        { value: "iob", label: "Indian Overseas Bank" },
        { value: "indusind_bank", label: "IndusInd Bank Ltd" },
        { value: "jammu_and_kashmir_bank", label: "Jammu and Kashmir Bank" },
        { value: "karnataka_bank", label: "Karnataka Bank" },
        { value: "kotak_mahindra_bank", label: "Kotak Mahindra Bank" },
        { value: "south_indian_bank", label: "South Indian Bank" },
        { value: "state_bank_of_india_netc", label: "State Bank of India" },
        { value: "uco_bank", label: "UCO Bank" },
        { value: "union_bank_of_india", label: "Union Bank of India" },
        { value: "yes_bank", label: "Yes Bank Ltd" },
        { value: "indian_highways_management_company_ltd", label: "IHMCL Bank" },
        { value: "livquik_technology_india_private_limited", label: "LivQuik/QuikWallet" }
    ];

    const handleMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        const marker = { latitude: lat, longitude: lng };
        setSelectedMarker(marker);
        setDetails((prev) => ({ ...prev, lat, lng }));
    };

    const handleMarkerClick = (marker) => {
        setSelectedMarker(marker);
        setDetails((prev) => ({
            ...prev,
            lat: marker?.latitude,
            lng: marker?.longitude,
            street: marker?.street,
            locality: marker?.area,
            city: marker?.city,
            state: marker?.state,
            country: marker?.country,
            pincode: marker?.pincode,
            hub: marker?.hubId
        }));
    };

    const registerDevice = async () => {
        if (!details?.odometer?.initial || isNaN(Number(details.odometer?.initial))) return toast.error("Invalid Start Km");
        if (!details?.fuel?.length || details?.fuel?.length !== carDetails?.fuelType?.length) return toast.error("Invalid Fuel Details");
        if (!details?.fasTag?.provider_name) return toast.error("Invalid Fastag Provider");
        if (!selectedMarker && !carDetails?.hub) return toast.error("Please select a marker on the map!");
        if (!details?.street?.trim()) return toast.error("Invalid Street");
        if (!details?.locality?.trim() && !details?.area?.trim()) return toast.error("Invalid Locality");
        if (!details?.city?.trim()) return toast.error("Invalid City");
        if (!details?.state?.trim()) return toast.error("Invalid State");
        if (!details?.country?.trim()) return toast.error("Invalid Country");
        if (!details?.pincode) return toast.error("Invalid Pincode");
        
        const services = service?.filter((el) => el?.changedDate && el?.changedKm && el?.serviceId);
        if (services?.length < serviceDetails?.length) return toast.error("All Service details are required");
        
        setButtonDisable(true);
        const data = { odometer: { initial: details.odometer?.initial }, hub: details.hub, services, fuel: details?.fuel, fasTag: details?.fasTag };
        const response = await Handler({ method: "PATCH", url: `/admin/car/device/${carDetails?.deviceId ? "update/" : ""}${id}`, data });
        
        if (response?.success) {
            toast.success(response.data?.message);
            setTimeout(() => {
                reloadWindowToPath(`/car/details/${id}`);
            }, 1500);
        } else {
            toast.error(response?.data?.message);
            setButtonDisable(false);
        }
    };

    const handleServiceChange = (name, value, index) => {
        setService((prev) =>
            prev.map((el, i) => {
                if (i === index) {
                    if (name === "serviceId") return { ...el, serviceName: value.label, serviceId: value.value };
                    return { ...el, [name]: value };
                }
                return el;
            })
        );
    };

    const getDetails = async () => {
        setButtonDisable(true);
        const hub = await Handler({ method: 'GET', url: `/admin/hub/active` });
        if (hub.success) setDeviceData(hub?.data?.data);
        const response = await Handler({ method: 'GET', url: `/admin/car/details/${id}` });
        if (response?.success) {
            const decryptedData = response?.data?.data;
            setDetails(decryptedData);
            setCarDetails(decryptedData);
            
            const model = await Handler({ method: 'GET', url: `/admin/vehicle/model/${decryptedData?.modelId}` });
            if (model?.success) {
                const data = model?.data?.data;
                const serviceDatas = data?.serviceDetails?.flatMap(value => {
                    if (value?.serviceFor === "common") return value?.serviceDetails || [];
                    if (value?.serviceFor === "transmissionType" && value?.forValue === decryptedData?.transmissionType) return value?.serviceDetails || [];
                    if (value?.serviceFor === "fuelType" && value?.forValue === decryptedData?.fuelType) return value?.serviceDetails || [];
                    return [];
                });
                if (serviceDatas?.length) {
                    setServiceDetails(serviceDatas.map(el => ({ label: el?.serviceName, value: el?.serviceId })));
                    setService(serviceDatas.map(el => ({ serviceId: el?.serviceId, changedDate: "", changedKm: "", serviceName: el?.serviceName })));
                }
            }
        }
        setButtonDisable(false);
    };

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (selectedMarker && mapRef.current) {
            mapRef.current.panTo({
                lat: selectedMarker.latitude,
                lng: selectedMarker.longitude
            });
        }
    }, [selectedMarker]);

    if (!isLoaded) {
        return <div>Loading Map...</div>;
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <BackButton className="mb-3" />
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-body">
                        <h4 className="text-center text-uppercase fw-bold mb-3 text-primary text-underline"> Device Details </h4>
                        <div className='row'>
                            <div className='col-xl-7'>
                                <GoogleMap
                                    mapContainerClassName="map-canvas-full"
                                    zoom={15}
                                    center={{ lat: deviceData?.length ? deviceData[0]?.latitude : 12.957639, lng: deviceData?.length ? deviceData[0]?.longitude : 80.142861 }}
                                    onLoad={(map) => (mapRef.current = map)}
                                    onClick={handleMapClick}
                                    options={{ disableDefaultUI: true, zoomControl: true }} >
                                    {deviceData?.map((marker, index) => (
                                        <Marker
                                            key={marker._id || index}
                                            position={{ lat: marker.latitude, lng: marker.longitude }}
                                            onClick={() => handleMarkerClick(marker)}
                                            draggable
                                            onDragEnd={(e) => {
                                                const lat = e.latLng.lat();
                                                const lng = e.latLng.lng();
                                                handleMarkerClick({ ...marker, latitude: lat, longitude: lng });
                                            }}
                                        />
                                    ))}
                                </GoogleMap>
                            </div>
                            <div className='col-xl-5 mt-xl-0 mt-4'>
                                <div className='mb-3'>
                                    <label className="form-label">Start KM</label>
                                    <input className='form-control' autoComplete='off' placeholder='Start KM' name="initial" value={details?.odometer?.initial || ""} disabled={disableButton} onChange={(e) => { if (!isNaN(e.target.value)) { setDetails((prev) => ({ ...prev, odometer: { initial: e.target.value } })) } }} />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label">Fuel Percentage</label>
                                    {
                                        carDetails?.fuelType?.length ?
                                            carDetails?.fuelType?.map((element, key) => {
                                                return (
                                                    <div className="form-floating mb-3" key={key}>
                                                        <input type="text" className="form-control mb-2" id={element} autoComplete='off' placeholder={element} name={element} value={details?.fuel?.length ? (details?.fuel?.find(fuel => fuel?.type === element)?.percentage || "") : ""} disabled={disableButton} onChange={(e) => { if (!isNaN(e.target.value) && Number(e.target.value) <= 100) { const type = details?.fuel?.length ? (details?.fuel?.find(fuel => fuel?.type === element) || {}) : {}; type['type'] = element; type['percentage'] = e.target.value; const filteredData = details?.fuel?.length ? details?.fuel?.filter(fuel => fuel?.type !== element) : []; filteredData?.push(type); setDetails((prev) => ({ ...prev, fuel: filteredData })) } }} />
                                                        <label htmlFor={element}>{element}</label>
                                                    </div>
                                                )
                                            })
                                            : ""
                                    }
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label">FastTag</label>
                                    <Select
                                        value={ details?.fasTag?.provider_value ? options.find( item => item.value === details?.fasTag?.provider_value ) : null }
                                        onChange={(option) => {
                                            setDetails((prevState) => ({
                                                ...prevState,
                                                fasTag: {
                                                    provider_name: option?.label,
                                                    provider_value: option?.value
                                                }
                                            }));
                                        }}
                                        isDisabled={disableButton}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? "#44084E" : base.borderColor,
                                                boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                "&:hover": { borderColor: "#44084E" }
                                            }),
                                            option: (style, state) => ({
                                                ...style,
                                                backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
                                                color: state.isSelected ? "white" : "black",
                                                ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
                                            })
                                        }}
                                        options={options}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label">Street</label>
                                    <input placeholder="Street" autoComplete='off' id="street" name='street' className='form-control' disabled={true} value={details?.street || ""} />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label">Locality</label>
                                    <input autoComplete='off' placeholder="Locality" id="locality" name='locality' className='form-control' disabled={true} value={details?.locality || details?.area || ""} />
                                </div>
                                <div className='d-flex gap-5' >
                                    <div className='mb-3'>
                                        <label className="form-label">City</label>
                                        <input autoComplete='off' placeholder="City" id="city" name='city' className='form-control' disabled={true} value={details?.city || ""} />
                                    </div>
                                    <div className='mb-3'>
                                        <label className="form-label">State</label>
                                        <input autoComplete='off' placeholder="State" id="state" name='state' className='form-control' disabled={true} value={details?.state || ""} />
                                    </div>
                                </div>
                                <div className='d-flex gap-5' >
                                    <div className='mb-3'>
                                        <label className="form-label">Country</label>
                                        <input autoComplete='off' placeholder="Country" id="country" name='country' className='form-control' disabled={true} value={details?.country || ""} />
                                    </div>
                                    <div className='mb-3'>
                                        <label className="form-label">Pincode</label>
                                        <input autoComplete='off' placeholder="Pincode" id="pincode" name='pincode' className='form-control' disabled={true} value={details?.pincode || ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card border-0 shadow-sm rounded-4 mt-3">
                    <div className="card-body">
                        {
                            service?.length && !carDetails?.deviceId ?
                                <div>
                                    <h4 className="text-center text-uppercase fw-bold mb-3 text-primary text-underline"> Service Details </h4>
                                    {service?.map((element, i) => {
                                        return (
                                            <div className="row align-items-center my-2" key={i}>
                                                <div className='col-sm-3'>
                                                    <label className='text-capitalize form-label'>{element?.serviceName}</label>
                                                </div>
                                                <div className='col-sm-4'>
                                                    <input placeholder="Changed Km" name="changedKm" autoComplete="off" disabled={disableButton} className='form-control' onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleServiceChange('changedKm', e.target.value, i) } }} type="text" value={element?.changedKm || ""} />
                                                </div>
                                                <div className='service-details col-md-4'>
                                                    <DatePicker placeholder='Changed Date' maxDate={new Date()} style={{ width: '100%', textAlign: 'start' }} className='calender-theme' format='DD-MM-YYYY' inputClass="date-theme form-control" onChange={(e) => {
                                                        setService(service?.map((element, index) => {
                                                            if (index === i) {
                                                                let changedDate = new Date(e);
                                                                element['changedDate'] = (changedDate?.getDate() < 10 ? ("0" + changedDate?.getDate()) : changedDate?.getDate()) + "-" + ((changedDate?.getMonth() + 1) < 10 ? ("0" + (changedDate?.getMonth() + 1)) : (changedDate?.getMonth() + 1)) + "-" + changedDate?.getFullYear();
                                                            }
                                                            return element;
                                                        }))
                                                    }} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                : ""
                        }
                        <div className='text-center'> <button className='btn btn-success' disabled={disableButton} onClick={registerDevice} >Submit</button> </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CarDevice;